<template>

<div class="row d-flex justify-content-center">
    <div class="col-xl-10 col-12">
        <div class="card card-plan card-profile border-0 shadow-lg mb-5 mt-2 ml-2 mr-2">
            <div class="card-header d-flex flex-column align-items-center">
                <div class="icon-profile">
                    <span class="icon icon-mail text-gold"></span>
                </div>
                <h5 class="text-center text-uppercase font-weight-bold">
                    Newsletter
                </h5>
            </div>

            <div class="card-body pt-0 text-lg-left">
                <div v-if='isReady' class="row">
                    <div v-if='hasNL' class="col-12">
                        <div class="d-flex alert alert-success justify-content-between align-items-center flex-column flex-md-row">
                            <span class="d-flex align-items-center flex-column flex-md-row text-md-left">
                                <span class="material-icons-round mr-md-3 mt-2 mt-md-0 subscribe-icon">
                                    &#xf18c;
                                </span>
                                You have subscribed for our newsletter.
                            </span>
                            <button @click='nlUpdate(0)' class='btn btn-primary d-flex mt-2 mt-md-0 mb-3 mb-md-0 align-items-center'>
                                <span class="material-icons-round mr-2">
                                    &#xe888;
                                </span>
                                Unsubscribe
                            </button>
                        </div>
                    </div>      
                    <div v-if='!hasNL' class="col-12">
                        <div class="d-flex alert alert-warning justify-content-between align-items-center flex-column flex-md-row">
                            <span class="d-flex align-items-center flex-column flex-md-row text-md-left">
                                <span class="material-icons-round mr-md-3 mt-2 mt-md-0 subscribe-icon">
                                    &#xe811;
                                </span>
                                You are not subscribed for our newsletter.
                            </span>

                            <button @click='nlUpdate(1)' class='btn btn-warning mt-2 mt-md-0 mb-3 mb-md-0 align-items-center'>
                                <span class="material-icons-round mr-2">
                                    &#xe92d;
                                </span>
                                Subscribe
                            </button>
                        </div>
                    </div>          
                </div>
            </div>
        </div>
    </div>
</div>


</template>

<script>
    export default {

        mounted() {
            this.check();
        },

        created() {
           
        },

        data() {
            return {
                isReady : false,
                hasNL   : false,
            }
        },

        methods : {

            check() {
                
                this.ajax.call('usr:nlcheck', {}, (r) => {
                    if( r.status == 'success' ) {
                        this.isReady = true;
                        this.hasNL = r.data.nl == 1 ? true : false;
                    }

                })

            },

            nlUpdate( status ) {
                this.ajax.call('usr:nlup', { s : status }, (r) => {
                    
                    if( r.status == 'success' ) {
                        this.hasNL = status == 1 ? true : false;
                    }

                })
            }

        }

    }
</script>
